import React, { Component, ReactNode } from "react";
import { localize } from "src/l10n";
import { Dialog, DialogType, DialogFooter } from '@fluentui/react/lib/Dialog';
import { Dropdown, IDropdownOption } from '@fluentui/react/lib/Dropdown';
import { Loader } from "src/ui";
import {
    PrimaryButton
} from '@fluentui/react';
import ThemeContext from "src/style/ThemeContext";
import api from "src/spintr/SpintrApi";
import PopupHeader from "../../PopupHeader";

interface IProps {
    editor: any,
    onClose: any
}

interface IState {
    isLoading: any,
    forms?: any,
    selectedForm?: any
}

class TinyFormFunction extends Component<IProps, IState> {
    public static contextType = ThemeContext;

    constructor(props: IProps) {
        super(props);

        this.state = {
            isLoading: true
        };
    }

    componentDidMount() {
        this.fetch();
    }

    fetch() {
        this.setState({
            isLoading: true
        }, () => {
            api.get("/api/survey/formlist").then((response) => {
                for (let form of response.data) {
                    form.key = form.id;
                    form.text = form.name;
                }

                this.setState({
                    forms: response.data,
                    isLoading: false
                });
            });
        });
    }

    formSelected() {
        const html = '<div><span class="redactorInlineFolder form-' + this.state.selectedForm.id + '">' + this.state.selectedForm.name + '</span></div> <br />';

        this.props.editor.insertContent(html);

        this.props.onClose();
    }

    public render(): ReactNode {
        return (
            <Dialog
                hidden={false}
                containerClassName="dialogWithPopupHeader"
                onDismiss={this.props.onClose}
                modalProps={{
                    isBlocking: true,
                    allowTouchBodyScroll: true
                }}
                dialogContentProps={{
                    type: DialogType.normal,
                    title: localize("Formular"),
                    showCloseButton: true,
                    closeButtonAriaLabel: localize("Stang"),
                }}>
                <PopupHeader
                    text={localize("Formular")}
                    onClose={this.props.onClose} />
                {
                    this.state.isLoading ?
                        <Loader /> :
                        <div>
                            <Dropdown
                                //label={localize("Formular")}
                                selectedKey={!!this.state.selectedForm ? this.state.selectedForm.key : null}
                                onChange={(event: React.FormEvent<HTMLDivElement>, item: IDropdownOption) => {
                                    this.setState({
                                        selectedForm: item
                                    });
                                }}
                                options={this.state.forms}
                                placeholder={localize("SELECT_FORM")}
                            />
                            <DialogFooter>
                                <PrimaryButton
                                    theme={this.context}
                                    onClick={this.formSelected.bind(this)}
                                    text={localize("Valj")} />
                            </DialogFooter>
                        </div>
                }
            </Dialog>
        );
    }

}

export default TinyFormFunction;